import React from 'react';
import { useTheme } from '@mui/material/styles';
import {Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, useMediaQuery, Link} from '@mui/material/';

interface Props {
    isDialogOpen: boolean,
    closeDialog: ()=> void
}

const RequestAdvisoryOpinion = (props: Props): JSX.Element => {
  
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Dialog
        fullScreen={fullScreen}
        open={props.isDialogOpen}
        onClose={props.closeDialog}
        maxWidth={'md'}
        aria-labelledby="how to request an advisory opinion"
      >
        <DialogTitle>
          Requesting an Advisory Opinion
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
          <>
                        <p>
                            Any person may request an advisory opinion concerning the specific application of the campaign
                            finance law or OCPF's regulations. All advisory opinion requests must be in writing and may be
                            submitted by e-mail, fax or mail. Advisory opinion requests should include the following:
                        </p>
                        <ul>
                            <li>The requesting party's name, address, phone number, and email address;</li>
                            <li>A description of a specific activity or transaction that has not yet occurred;</li>
                            <li>A specific question or questions about the proposed activity or transaction; and</li>
                            <li>Any accompanying data, views or arguments that the requesting person deems pertinent.</li>
                        </ul>
                        <p>
                            The Director will review all requests for Advisory Opinions. They may request that additional or
                            more specific information or questions be submitted by the requesting person. After reviewing
                            the request, the Director may determine that:
                        </p>
                        <ul>
                            <li>
                                A particular request for an advisory opinion poses issues which are not within OCPF's
                                jurisdiction;
                            </li>
                            <li>The questions posed are not appropriate to an advisory opinion; or</li>
                            <li>Sufficient information has not been provided by the requesting person.</li>
                        </ul>
                        <p>
                            In the event the Director determines that an Advisory Opinion is not warranted, they may choose
                            to decline to issue the opinion. If the Director declines to issue an opinion, they will, within
                            a reasonable time, notify the requesting person that the advisory opinion will not be rendered.
                            Otherwise, an Advisory Opinion will be rendered in a timely fashion.
                        </p>
                        <p>
                            All advisory opinion requests and all advisory opinions shall be public records, under M.G.L.
                            c. 4, § 7, and shall be subject to public inspection as required by M.G.L. c. 66, § 10.
                        </p>
                        <p>
                            You may file a written request for an Advisory Opinion with the Office of Campaign and
                            Political Finance in any of the following ways:
                        </p>
                        <ul>
                            <li>
                                <Link href="mailto:ocpf@mass.gov?subject=Advisory Opinion Request">
                                    Email Your Request
                                </Link>
                            </li>
                            <li>fax:  (617) 727-6549 or</li>
                            <li>
                                US Mail:  Office of Campaign and Political Finance<br />
                                One Ashburton Place, Room 411<br />
                                Boston, MA 02108<br />
                                Attention:  Advisory Opinion request
                            </li>
                        </ul>
          </>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button onClick={props.closeDialog}>Close</Button>
        </DialogActions>
      </Dialog>
  );
};

export default RequestAdvisoryOpinion;
